import { Link } from "react-router-dom";
import { PiggyBank } from "lucide-react";

export const Brand = ({ to = "/", size = "md" }) => {
  const big = size === "lg";
  return (
    <Link to={to} data-testid="brand-logo-link" className="inline-flex items-center gap-3 group">
      <span className={`grid place-items-center rounded-2xl bg-emerald-700 text-amber-200 shadow-md transition-transform duration-300 group-hover:-rotate-6 ${big ? "h-16 w-16" : "h-12 w-12"}`}>
        <PiggyBank className={big ? "h-9 w-9" : "h-7 w-7"} strokeWidth={2.2} />
      </span>
      <span className="leading-none">
        <span
          data-testid="brand-name"
          className={`block font-heading font-extrabold text-emerald-950 ${
            big ? "text-3xl sm:text-4xl" : "text-2xl"
          }`}
        >
          CofreWeb
        </span>
      </span>
    </Link>
  );
};
